/*
 * Copyright (C) 2020-present Borza LLC. All rights reserved.
 */

import CollectionKind from "../enums/collection-kind";

const Certifications = ({ collection }: { collection: CollectionKind }) => (
  <div className="sm:text-left text-center">
    {collection === CollectionKind.LipBalm && (
      <>
        <figure className="align-top inline-block m-2 text-center w-20">
          <img
            alt=""
            className="h-12 inline-block w-12"
            role="presentation"
            src={require("../public/icons/shields/certified-organic.svg") as string}
          />
          <figcaption className="font-medium font-serif text-xs">Certified Organic</figcaption>
        </figure>
        <span>{" "}</span>
      </>
    )}
    {collection === CollectionKind.LipScrub && (
      <>
        <figure className="align-top inline-block m-2 text-center w-20">
          <img
            alt=""
            className="h-12 inline-block w-12"
            role="presentation"
            src={require("../public/icons/shields/certified-organic.svg") as string}
          />
          <figcaption className="font-medium font-serif text-xs">Certified Organic Ingredients</figcaption>
        </figure>
        <span>{" "}</span>
      </>
    )}
    <figure className="align-top inline-block m-2 text-center w-20">
      <img
        alt=""
        className="h-12 inline-block w-12"
        role="presentation"
        src={require("../public/icons/shields/certified-cruelty-free.svg") as string}
      />
      <figcaption className="font-medium font-serif text-xs">Certified Cruelty&nbsp;Free</figcaption>
    </figure>
    <span>{" "}</span>
    {(collection === CollectionKind.LipBalm || collection === CollectionKind.LipScrub) && (
      <>
        <figure className="align-top inline-block m-2 text-center w-20">
          <img
            alt=""
            className="h-12 inline-block w-12"
            role="presentation"
            src={require("../public/icons/shields/dermatologist-approved.svg") as string}
          />
          <figcaption className="font-medium font-serif text-xs">Dermatologist Approved</figcaption>
        </figure>
        <span>{" "}</span>
      </>
    )}
    <figure className="align-top inline-block m-2 text-center w-20">
      <img
        alt=""
        className="h-12 inline-block w-12"
        role="presentation"
        src={require("../public/icons/shields/sustainable-and-fair-trade.svg") as string}
      />
      <figcaption className="font-medium font-serif text-xs">Sustainable &amp; Fair&nbsp;Trade</figcaption>
    </figure>
    <span>{" "}</span>
    {(collection === CollectionKind.LipBalm || collection === CollectionKind.LipScrub) && (
      <>
        <figure className="align-top inline-block m-2 text-center w-20">
          <img
            alt=""
            className="h-12 inline-block w-12"
            role="presentation"
            src={require("../public/icons/shields/free-of-chemicals.svg") as string}
          />
          <figcaption className="font-medium font-serif text-xs">Free&nbsp;of Chemicals</figcaption>
        </figure>
        <span>{" "}</span>
      </>
    )}
    {collection === CollectionKind.LipBalm && (
      <>
        <figure className="align-top inline-block m-2 text-center w-20">
          <img
            alt=""
            className="h-12 inline-block w-12"
            role="presentation"
            src={require("../public/icons/shields/100-upcycled-pcr-materials.svg") as string}
          />
          <figcaption className="font-medium font-serif text-xs">100% Upcycled PCR&nbsp;Materials</figcaption>
        </figure>
        <span>{" "}</span>
      </>
    )}
    {collection === CollectionKind.LipScrub && (
      <>
        <figure className="align-top inline-block m-2 text-center w-20">
          <img
            alt=""
            className="h-12 inline-block w-12"
            role="presentation"
            src={require("../public/icons/shields/100-upcycled-pcr-materials.svg") as string}
          />
          <figcaption className="font-medium font-serif text-xs">PCR &amp; Sugarcane Material Packaging</figcaption>
        </figure>
        <span>{" "}</span>
      </>
    )}
    <figure className="align-top inline-block m-2 text-center w-20">
      <img
        alt=""
        className="h-12 inline-block w-12"
        role="presentation"
        src={require("../public/icons/shields/made-in-usa.svg") as string}
      />
      <figcaption className="font-medium font-serif text-xs">Made in<br />USA</figcaption>
    </figure>
    <span>{" "}</span>
    <figure className="align-top inline-block m-2 text-center w-20">
      <img
        alt=""
        className="h-12 inline-block w-12"
        role="presentation"
        src={require("../public/icons/shields/product-give-back.svg") as string}
      />
      <figcaption className="font-medium font-serif text-xs">Product Give&nbsp;Back</figcaption>
    </figure>
    <span>{" "}</span>
    <figure className="align-top inline-block m-2 text-center w-20">
      <img
        alt=""
        className="h-12 inline-block w-12"
        role="presentation"
        src={require("../public/icons/shields/female-founded-and-owned.svg") as string}
      />
      <figcaption className="font-medium font-serif text-xs">Female Founded &amp;&nbsp;Owned</figcaption>
    </figure>
  </div>
);

export default Certifications;
